/**
 * ALIAS ROUTES
 * An alias of /a as /b means when the user visits /b, the URL remains /b, but it will be matched as if the user is visiting /a.
 */
export default [
  {
    path: '/tour/team360enterprise/redirect-demo',
    name: 'alias-tour-demo',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'dev-customer.360tovisit.com' ? '/' : undefined
  },
  {
    path: '/tour/ralphlaurenjapan/virtual-showroom',
    name: 'alias-tour-demo',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'customer.360tovisit.com' ? '/' : undefined
  },

  {
    path: '/tour/ralphlaurenjapan/virtual-showroom',
    name: 'alias-tour-demo',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'virtualshowroom.ralphlauren.co.jp' ? '/' : undefined
  },

  {
    path: '/tour/ralphlaurenjapan/ralph-lauren-japan-virtual-catalog-spring-2021',
    name: 'alias-tour-virtualcatalog',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'virtualcatalog.ralphlauren.co.jp' ? '/' : undefined
  },

  {
    path: '/tour/wineofportugal/wine-of-portugal',
    name: 'alias-tour-stg-wineofportugal',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'stg-wineofportugal.360tovisit.com' ? '/' : undefined
  },

  {
    path: '/tour/wineofportugal/wines-of-portugal-virtual-experience',
    name: 'alias-tour-winesofportugalvirtual',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'winesofportugalvirtualexperience.com' ? '/' : undefined
  },

  {
    path: '/tour/wineofportugal/wines-of-portugal-virtual-experience',
    name: 'alias-tour-winesofportugalvirtual',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/' : undefined
  },

  //Mini-sites on the develop server
  {
    path: '/tour/saturnlai/devops-testing',
    name: 'alias-tour-devops-testing',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'dev-customer.360tovisit.com' ? '/devops-testing' : undefined
  },

  //Mini-sites on the staging server
  {
    path: '/tour/saturnlai/development-main-wipo',
    name: 'alias-tour-stg-development-main-wipo',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'stg-wineofportugal.360tovisit.com' ? '/development-main-wipo' : undefined
  },
  
  // Mini-sites on the production server
  {
    path: '/tour/wineofportugal/wines-and-winemakers-by-saven',
    name: 'alias-tour-wines-and-winemakers-by-saven',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/wines-and-winemakers-by-saven' : undefined
  },

  {
    path: '/tour/wineofportugal/taboadella',
    name: 'alias-tour-taboadella',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/taboadella' : undefined
  },

  {
    path: '/tour/wineofportugal/reynolds-wine-growers',
    name: 'alias-tour-reynolds-wine-growers',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/reynolds-wine-growers' : undefined
  },

  {
    path: '/tour/wineofportugal/ramos-pinto',
    name: 'alias-tour-ramos-pinto',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/ramos-pinto' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-nova-de-nossa-senhora-do-carmo',
    name: 'alias-tour-quinta-nova-de-nossa-senhora-do-carmo',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-nova-de-nossa-senhora-do-carmo' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-dos-avidagos-douro-wine-producer',
    name: 'alias-tour-quinta-dos-avidagos-douro-wine-producer',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-dos-avidagos-douro-wine-producer' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-do-paral',
    name: 'alias-tour-quinta-do-paral',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-do-paral' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-do-couquinho-sociedade-agricola',
    name: 'alias-tour-quinta-do-couquinho-sociedade-agricola',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-do-couquinho-sociedade-agricola' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-do-conde',
    name: 'alias-tour-quinta-do-conde',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-do-conde' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-de-s-sebastiao',
    name: 'alias-tour-quinta-de-s-sebastiao',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-de-s-sebastiao' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-da-sequeira',
    name: 'alias-tour-quinta-da-sequeira',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-da-sequeira' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-da-romaneira',
    name: 'alias-tour-quinta-da-romaneira',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-da-romaneira' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-da-pacheca',
    name: 'alias-tour-quinta-da-pacheca',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-da-pacheca' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-da-lagoalva-de-cima',
    name: 'alias-tour-quinta-da-lagoalva-de-cima',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-da-lagoalva-de-cima' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-da-devesa',
    name: 'alias-tour-quinta-da-devesa',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-da-devesa' : undefined
  },

  {
    path: '/tour/wineofportugal/quinta-da-casaboa',
    name: 'alias-tour-quinta-da-casaboa',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/quinta-da-casaboa' : undefined
  },

  {
    path: '/tour/wineofportugal/jose-maria-da-fonseca',
    name: 'alias-tour-jose-maria-da-fonseca',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/jose-maria-da-fonseca' : undefined
  },

  {
    path: '/tour/wineofportugal/herdade-paco-do-conde',
    name: 'alias-tour-herdade-paco-do-conde',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/herdade-paco-do-conde' : undefined
  },

  {
    path: '/tour/wineofportugal/herdade-de-coelheiros',
    name: 'alias-tour-herdade-de-coelheiros',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/herdade-de-coelheiros' : undefined
  },

  {
    path: '/tour/wineofportugal/herdade-da-calada',
    name: 'alias-tour-herdade-da-calada',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/herdade-da-calada' : undefined
  },

  {
    path: '/tour/wineofportugal/falua-tejos-wine-from-portugal',
    name: 'alias-tour-falua-tejos-wine-from-portugal',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/falua-tejos-wine-from-portugal' : undefined
  },

  {
    path: '/tour/wineofportugal/encostas-de-alqueva-abegoaria',
    name: 'alias-tour-encostas-de-alqueva-abegoaria',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/encostas-de-alqueva-abegoaria' : undefined
  },

  {
    path: '/tour/wineofportugal/colinas-do-douro',
    name: 'alias-tour-colinas-do-douro',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/colinas-do-douro' : undefined
  },

  {
    path: '/tour/wineofportugal/casa-santos-lima',
    name: 'alias-tour-casa-santos-lima',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/casa-santos-lima' : undefined
  },

  {
    path: '/tour/wineofportugal/casa-relvas',
    name: 'alias-tour-casa-relvas',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/casa-relvas' : undefined
  },

  {
    path: '/tour/wineofportugal/casal-da-coelheira',
    name: 'alias-tour-casal-da-coelheira',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/casal-da-coelheira' : undefined
  },

  {
    path: '/tour/wineofportugal/casal-branco',
    name: 'alias-tour-casal-branco',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/casal-branco' : undefined
  },

  {
    path: '/tour/wineofportugal/casa-ermelinda-freitas',
    name: 'alias-tour-casa-ermelinda-freitas',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/casa-ermelinda-freitas' : undefined
  },

  {
    path: '/tour/wineofportugal/carmim',
    name: 'alias-tour-carmim',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/carmim' : undefined
  },

  {
    path: '/tour/wineofportugal/caminhos-cruzados',
    name: 'alias-tour-caminhos-cruzados',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/caminhos-cruzados' : undefined
  },

  {
    path: '/tour/wineofportugal/aveleda',
    name: 'alias-tour-aveleda',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/aveleda' : undefined
  },

  {
    path: '/tour/wineofportugal/adega-ponte-da-barca-viniverde',
    name: 'alias-tour-adega-ponte-da-barca-viniverde',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/adega-ponte-da-barca-viniverde' : undefined
  },

  {
    path: '/tour/wineofportugal/adega-mayor',
    name: 'alias-tour-adega-mayor',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/adega-mayor' : undefined
  },

  {
    path: '/tour/wineofportugal/adega-de-portalegre-winery',
    name: 'alias-tour-adega-de-portalegre-winery',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/adega-de-portalegre-winery' : undefined
  },

  {
    path: '/tour/wineofportugal/adega-cooperativa-de-vidigueira-cuba-e-alvito-crl',
    name: 'alias-tour-adega-cooperativa-de-vidigueira-cuba-e-alvito-crl',
    component: () => import('@/components/preview/Index'),
    alias: window.location.host === 'www.winesofportugalvirtualexperience.com' ? '/adega-cooperativa-de-vidigueira-cuba-e-alvito-crl' : undefined
  }
]


// WEBPACK FOOTER //
// ./src/router/alias.js